import ActionFooter from '@components/components/HeatInstallationForm/components/ActionFooter/ActionFooter';

export default ActionFooter;
